import React from "react";
import { styled } from "@material-ui/core/styles";
import { Typography, Box } from "@material-ui/core";
import packageJson from "../../../package.json";

const FooterContainer = styled(Box)(({ theme }) => ({
  width: "100%",
  backgroundColor: "#007A53",
  color: "#fff",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  padding: theme.spacing(1, 3),
  position: "fixed",
  bottom: 0,
  left: 0,
  fontSize: "14px",
}));

export default function Footer() {
  return (
    <FooterContainer>
      <Typography variant="body2">
        <strong>Copyright © {new Date().getFullYear()} </strong>
        <span style={{ color: "#3b82f6", fontWeight: "bold" }}></span>. 
        All rights reserved.
      </Typography>

      <Typography variant="body2" style={{ fontWeight: "bold" }}>
        Version {packageJson.version}
      </Typography>
    </FooterContainer>
  );
}
